import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { registerUserEmail } from "../store/authSlice";
import ContinueButton from "./ContinueButton";
import { useNavigate } from "react-router-dom";

const EmailForm = () => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { buyerId, isParamsExist } = useSelector((state) => state.params);

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleEmailBlur = () => {
    if (!validateEmail(email)) {
      setEmailError("Enter a valid email.");
      return;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEmailError("");

    if (!email) {
      setEmailError("Email is required");
      return;
    }
    if (!validateEmail(email)) {
      setEmailError("Enter a valid email.");
      return;
    }

    try {
      const result = await dispatch(registerUserEmail({ email }));
      if (result.payload.status) {
        navigate(isParamsExist && buyerId ? `/verify-email?buyerId=${buyerId}` : "/verify-email", { state: { email } });
      }
      if (result.payload.message === "A user with this email already exists") {
        setEmailError("A user with this email already exists. Please Log in.");
      } else {
        setEmailError(result.payload.message);
      }
    } catch (error) {
      setEmailError("An error occurred during registration.");
    }
  };

  return (
    <>
      <section className="flex flex-col items-center min-h-screen justify-center bg-white py-10 overflow-scroll px-6 pt-[155px]">
        <header className="text-center mb-14">
          <h1 className="text-2xl font-semibold text-[#1d2639]">
            Let’s Get Started
          </h1>
          <p className="text-base font-medium text-[#7e7e7e] w-full sm:w-[394px]">
            Enter your email to begin. If you don’t have an account, we’ll send
            you a verification code.
          </p>
        </header>

        <form
          className="flex flex-col justify-center w-full sm:w-[572px]"
          onSubmit={handleSubmit}
          aria-labelledby="form-title"
        >
          <h1 id="form-title" className="sr-only">
            User Email
          </h1>

          <fieldset
            className="w-full h-auto flex flex-col justify-center items-start gap-2 mb-10"
            aria-labelledby="email-label"
            aria-describedby="email-error"
          >
            <legend className="sr-only">User Email</legend>

            <label
              htmlFor="email"
              id="email-label"
              className="text-[#1d2639] text-base font-normal font-['Lato']"
            >
              Email
            </label>

            <input
              type="email"
              id="email"
              name="email"
              placeholder="Enter your Email"
              className={`w-full h-12 p-3 bg-[#f9f9f9] rounded-lg border-2 ${
                emailError ? "border-solid border-1 border-red-500" : ""
              }`}
              value={email}
              onBlur={handleEmailBlur}
              onChange={(e) => {
                setEmail(e.target.value);
                if (emailError) setEmailError("");
              }}
              aria-describedby="email-error"
            />
            {emailError && (
              <span
                id="email-error"
                className="text-red-500 text-sm"
                role="alert"
              >
                {emailError}
              </span>
            )}
          </fieldset>

          <ContinueButton
            isDisabled={!email || emailError}
            onClick={handleSubmit}
          />
        </form>
      </section>
    </>
  );
};

export default EmailForm;
